var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7078 0.397739L39.5912 9.03977C40.1363 9.57009 40.1363 10.4299 39.5912 10.9602L30.7078 19.6023C30.1627 20.1326 29.2788 20.1326 28.7337 19.6023C28.1886 19.0719 28.1886 18.2121 28.7337 17.6818L35.2341 11.358H0V8.64204H35.2341L28.7337 2.31819C28.1886 1.78787 28.1886 0.928057 28.7337 0.397739C29.2788 -0.13258 30.1627 -0.13258 30.7078 0.397739Z",
    fill: "#A5ADBA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default ForwardRef;